import md5 from "md5";
import { getMonthsArray } from "../";

type TariffRow = {
  id: string;
  ts: string;
  [key: string]: string | number;
};

type TariffHourly = {
  ts: string;
  tariff: string | number;
};

type TariffTaxData = {
  meteringPointId?: string | number;
  [tax: string]: TariffHourly[] | any;
};

type TariffData = {
  tariffDetails?: {
    taxes?: TariffTaxData[];
    month?: number;
  };
};

export const tariffMonthlyRows = (
  data: TariffData,
  taxName: string,
  gettext: (key: string) => string,
) => {
  const rows: Record<string, TariffRow[]> = {};

  const taxesData = data?.tariffDetails?.taxes;
  const monthsArray = getMonthsArray(gettext);
  const monthIndex = data?.tariffDetails?.month || 0;
  const selectedMonth = monthsArray[monthIndex].value;

  // if (data?.consumptionEnergyData?.consumptionData[0]?.details?.data[0]?.meter) {
  if (Array.isArray(taxesData) && taxesData.length > 0) {
    taxesData.map((objTaxesData): null => {
      const orderNo = objTaxesData?.meteringPointId;
      const orderKey = String(orderNo);

      if (!rows["all"]) {
        rows["all"] = [];
      }

      if (!rows[selectedMonth]) {
        rows[selectedMonth] = [];
      }

      (objTaxesData as any)[taxName].map((hourlyData: TariffHourly): null => {
        const rowIndex: Record<string, number> = {};
        const id = md5(hourlyData.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][orderKey] = hourlyData.tariff;
        } else {
          const row: TariffRow = {
            id: id,
            ts: hourlyData.ts,
          };
          row[orderKey] = hourlyData.tariff;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][orderKey] =
            hourlyData.tariff;
        } else {
          const row: TariffRow = {
            id: id,
            ts: hourlyData.ts,
          };
          row[orderKey] = hourlyData.tariff;
          rows[selectedMonth].push(row);
        }
        return null;
      });
      return null;
    });
  }

  return rows;
};
